/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CouponCountDto } from '../../models/coupon-count-dto';

export interface ParentCouponControllerGetCount$Params {

/**
 * 관리자 전용 즐겨찾기 여부
 */
  isFavoriteForAdmin?: boolean;

/**
 * 자동 발급 쿠폰 ID
 */
  autoIssuedCouponId?: string;

/**
 * 회원 ID
 */
  userId?: string;

/**
 * 회원 ID
 */
  parentId?: string;

/**
 * 상품 ID
 */
  productIds?: Array<string>;

/**
 * 역할
 */
  memberRole?: 'PARENT' | 'TEACHER';

/**
 * 상태
 */
  status?: 'WAITING' | 'ACTIVE' | 'STOPPED' | 'EXPIRED' | 'COMPLETED' | 'CANCELED';

/**
 * 회원 조회 여부 (회원 조회 시 만료, 중지된 쿠폰은 보여지지 않습니다.)
 */
  searchByUser?: boolean;

/**
 * 사용자 세그먼트
 */
  segment?: 'AVAILABLE' | 'USED';

/**
 * 발행 대상
 */
  segment2?: 'ALL' | 'PERSONAL' | 'CENTER';

/**
 * 발행 대상 센터 ID
 */
  centerId?: string;

/**
 * 자동 발급된 쿠폰 보지 않기 여부
 */
  noAuto?: boolean;

/**
 * 카테고리 레벨
 */
  categoryLevel?: number;

/**
 * 대분류 카테고리 리스트
 */
  bigCategories?: Array<string>;

/**
 * 중분류 카테고리 리스트
 */
  mediumCategories?: Array<string>;

/**
 * 발행 대상
 */
  targetType?: 'CENTER' | 'TEACHER' | 'PARENT';
}

export function parentCouponControllerGetCount(http: HttpClient, rootUrl: string, params?: ParentCouponControllerGetCount$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponCountDto>> {
  const rb = new RequestBuilder(rootUrl, parentCouponControllerGetCount.PATH, 'get');
  if (params) {
    rb.query('isFavoriteForAdmin', params.isFavoriteForAdmin, {});
    rb.query('autoIssuedCouponId', params.autoIssuedCouponId, {});
    rb.query('userId', params.userId, {});
    rb.query('parentId', params.parentId, {});
    rb.query('productIds', params.productIds, {});
    rb.query('memberRole', params.memberRole, {});
    rb.query('status', params.status, {});
    rb.query('searchByUser', params.searchByUser, {});
    rb.query('segment', params.segment, {});
    rb.query('segment2', params.segment2, {});
    rb.query('centerId', params.centerId, {});
    rb.query('noAuto', params.noAuto, {});
    rb.query('categoryLevel', params.categoryLevel, {});
    rb.query('bigCategories', params.bigCategories, {});
    rb.query('mediumCategories', params.mediumCategories, {});
    rb.query('targetType', params.targetType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CouponCountDto>;
    })
  );
}

parentCouponControllerGetCount.PATH = '/api/parent-coupon/count';
